import styled, { keyframes } from 'styled-components';

const PromoHeroWrapper = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  width: 100%;
  padding: 0;
  background-color: #944000;
  ${({ backgroundImage }) =>
    backgroundImage &&
    `
        background-image: url(${backgroundImage});
        background-size: cover;
        background-position: top center;
        background-repeat: no-repeat;
    `}
`;

const fadeInUpAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInLeftAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Content = styled.div`
    position: relative;
    z-index: 2;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 20px;
    max-width: 90%;
    @media (max-width: 900px) {
      gap: 0;
      max-width: 100%;
    }  
`;

export const TopHeadingWrapper = styled.div`
  margin-bottom: 0;
  width: 950px;
  h1{
    color: ${({theme}) => theme.colours.yellow};
    font-size: clamp(3.5rem, 8.4vw, 8.25rem);
    font-weight: 900;
    text-transform: none;
    font-family: 'apercu pro', helvetica, verdana, sans-serif;
    text-align: left;
    margin: 0;
    line-height: 0.9;
    span{
      font-family: 'bordonaro', sans-serif;
      color: #fff;
      font-size: clamp(2.87rem, 6.4vw, 8rem);
    }
  }
  @media (max-width: 1500px) {
    width: 140%;
    h1{
        font-size: clamp(3.5rem, 7.4vw, 8.25rem);
    }
  }
  @media (max-width: 900px){
    width: 100%;
    max-width: 100%;
    h1{
      line-height: 1;
    }
  }
  @media (max-width: 450px){
    h1{
      font-size: 2.7rem;
    }
  }
`;

export const SubHeadingWrapper = styled.div`
  font-weight: 700;
  margin: 0;
  p{
    color: ${({theme}) => theme.colours.tan};
    font-family: apercu condensed pro, 'apercu pro', impact;
    font-size: clamp(22px, 6.4vw, 32px);
    line-height: 1.3;
    margin: 0;
  }
`;

export const CopyWrapper = styled.div`
  p {
    color: ${({theme}) => theme.colours.tan};
    font-size: clamp(18px, 6.4vw, 22px);
    font-family: 'apercu pro', helvetica, verdana, sans-serif;
    line-height: 1.3;
    margin: 0;
  }
`;

export const CopyDiv = styled.div`
	position: relative;
	display: flex;
	flex-flow: column;
	grid-column: span 6 / span 6;
	align-self: center;
	order: 0;
  padding: 80px 40px;
	.inner{
		width: 600px;
		max-width: 100%;
		margin: 0 0 50px 0;
		display: flex;
		flex-flow: column;
		gap: 30px;
	}
  @media (max-width: 1500px){
    padding: 50px 0;
  }
	@media (max-width: 1400px){
		.inner{
			margin: auto;
		}
	}
	@media (max-width: 900px){
		grid-column: span 12 / span 12;
    background-color: rgb(89, 42, 3);
    padding: 0;
		.inner{
			margin: auto;
			padding: 30px;
			width: calc(100% - 60px);
			max-width: calc(100% - 60px);
      gap: 15px;
		}
		order: 1;
		padding: 0;
	}
	@media (max-width: 600px){
		width: 100%;
		p{
			font-size: 18px;
		}
	}
`;

export const FadeInUpElement = styled.div`
	opacity: 0;
	animation: ${fadeInUpAnimation} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
`;
export const FadeInUpElementQuart = styled.div`
    opacity: 0;
    animation: ${fadeInUpAnimation} 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
`;

export const MediaDiv = styled.div`
	position: relative;
	display: flex;
	flex-flow: column;
	grid-column: span 6 / span 6;
	align-self: baseline;
	height: 100%;
	justify-content: end;
	order: 1;
	@media (max-width: 900px){
		grid-column: span 12 / span 12;
		padding: 0;
		order: 0;
	}
	@media (max-width: 600px){
		padding: 0;
	}
	img{
		opacity: 0;
		animation: ${fadeInLeftAnimation} 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
		max-width: 100%;
		max-height: 100%;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: bottom;
	}
`;
export default PromoHeroWrapper;